import type { IForemanCurtailmentPlanFilters } from '@/types/core/filters'
import type { IForemanCurtailmentPlan } from '@/types/core/ForemanCurtailmentPlan'
import axios from 'axios'

export async function getForemanCurtailmentPlans(
  filters: IForemanCurtailmentPlanFilters
): Promise<IForemanCurtailmentPlan[]> {
  const res = await axios.get(import.meta.env.VITE_APP_CORE_FOREMAN_CURTAILMENT_PLANS_ENDPOINT, {
    params: filters,
  })
  return res.data
}
